import React, { useState, useEffect } from "react";
import "./Results.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Scrollbar, A11y } from 'swiper/modules';
import "swiper/css";
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { db } from "../../../../firebase";

const Results = () => {
  const [database, setDatabase] = useState([]);

  useEffect(() => {
    const unsubscribe = db.collection("results_db").onSnapshot((snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        url: doc.data().photoUrl,
        course: doc.data().course,
        name: doc.data().name,
        score: doc.data().score,
        type: doc.data().type || 0,
      }));

      // Sort by type (ascending), then by score (descending)
      const sortedData = data.sort((a, b) => {
        if (a.type !== b.type) {
          return a.type - b.type;
        }
        // Parse score as float, handle %
        const scoreA = typeof a.score === 'string' ? parseFloat(a.score.replace('%', '')) : a.score;
        const scoreB = typeof b.score === 'string' ? parseFloat(b.score.replace('%', '')) : b.score;
        return scoreB - scoreA;
      });
      setDatabase(sortedData);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="results__container">
      <Swiper
        modules={[Autoplay, Pagination, Scrollbar, A11y]}
        spaceBetween={30}
        autoplay={{
          delay: 1000,
          disableOnInteraction: false,
        }}
        slidesPerView={5}
        loop={true}
      > {database.map((data, i) => (
          <SwiperSlide key={i}>
          <img className="slide__image" src={data.url} alt="" />
          <p className="slide__text">{data.name}</p>
          <p className="slide__text">{data.course}</p>
          <p className="slide__text">{data.score}</p>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Results;
